const formatName = (values: string[]): string => {
  const nonEmpties = values.filter(v => !!v);
  return nonEmpties.join(' ').trim();
};

export default formatName;
